




























import { defineComponent } from '@vue/composition-api';
import useStore from '../my/store';
import { yoda } from '@/utils/yoda';
import { getLangCode } from '@/utils/getLanguage';
import kwailog from '@/utils/kibtLogger';
import { setStorage } from '@/utils/storage';
import { isYodaEnv } from '@/utils/env';
import { LAUNCH_OPTION_PARAM, PAGE_HOME, PAGE_RECORD } from '../config';
import { openPage } from '@/utils/webview';

export default defineComponent({
    name: 'my-info',
    setup() {

        const langCode = getLangCode();

        const isZh = langCode?.split('-')[0] === 'zh';

        const store = useStore();

        const openRecord = () => {
            openPage(`${PAGE_RECORD}${store.isLiving ? LAUNCH_OPTION_PARAM : ''}`);
        };

        const goToVote = () => {
            if (!store.homeData.point) return;

            kwailog.sendClick({
                action: 'GO_TO_VOTE',
            });

            if (store.isSecondPage) {
                setStorage('global-midyear-warmup-myrankpos', '1');
                if (!isYodaEnv) {
                    window.history.go(-1);
                } else {
                    yoda.ready().then(() => {
                        yoda.component.backOrCloseWeb();
                    });
                }
            } else {
                // 分享回流打开 自身就是一级页
                window.location.replace(PAGE_HOME);
            }

        };

        return {
            isZh,
            store,
            openRecord,
            goToVote,
        };
    },
});
